import PropTypes from 'prop-types';

export const INVENTORY_BLOCK_STATUSES = {
    CANCELLED: 1,
    DEFINITE: 2,
    HOLD: 3,
    LOST: 4,
    PROSPECT: 5,
    STRONG_TENTATIVE: 6,
    TENTATIVE: 7,
    WEAK_TENTATIVE: 8,
};

export const allocationsBreakdownModel = {
    sellLimit: PropTypes.number,
    blockedRoomCount: PropTypes.number.isRequired,
    pickedUpRoomCount: PropTypes.number.isRequired,
    revenueEstimate: PropTypes.number,
    pickup: PropTypes.shape({
        rooms: PropTypes.shape({
            guaranteed: PropTypes.number.isRequired,
        }),
        revenue: PropTypes.shape({
            accommodation: PropTypes.shape({
                guaranteed: PropTypes.number.isRequired,
            }),
        }),
    }).isRequired,
};

export const inventoryBlockModel = {
    code: PropTypes.string.isRequired,
    name: PropTypes.string,
    status: PropTypes.number.isRequired,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    marketCode: PropTypes.string,
    sourceOfBusiness: PropTypes.string,
    createdDateTime: PropTypes.string,
    lastModifiedDateTime: PropTypes.string.isRequired,
    allocations: PropTypes.arrayOf(
        PropTypes.shape({
            stayDate: PropTypes.string.isRequired,
            ...allocationsBreakdownModel,
        }),
    ).isRequired,
    ...allocationsBreakdownModel,
};
